module.exports = __webpack_public_path__ + "kudos_4.svg?5cbbea00cb8c210e450558a415ba2c34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_4.svg
// module id = 139
// module chunks = 0